<template>
    <div v-if="providers.length" class="auth-oauth-wrap">
        <v-card-text class="text-center subtitle-1 font-weight-medium pt-1 pb-2">
            Ingresa con
        </v-card-text>
        <v-card-actions class="auth-oauth-actions justify-center">
            <v-btn
                v-for="item in providers"
                :key="item.provider"
                rounded
                large
                :dark="item.dark"
                :color="item.color"
                :loading="pendingProvider === item.provider"
                :disabled="pendingProvider !== null"
                class="auth-oauth-button px-4"
                @click="login(item.provider)">
                <v-icon left>{{ item.icon }}</v-icon>{{ item.label }}
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import {settings} from '../../../config';

export default {
    name: 'OAuthButtons',
    data() {
        return {
            pendingProvider: null,
            popup: null,
            providers: [
            {provider: 'google', label: 'Google', icon: 'mdi-google', color: 'red darken-4', dark: true},
            {provider: 'facebook', label: 'Facebook', icon: 'mdi-facebook', color: 'blue darken-4', dark: true},
            {provider: 'apple', label: 'Apple', icon: 'mdi-apple', color: 'black', dark: true}
            ].filter(item => Boolean(settings[item.provider]))
        };
    },
    mounted() {
        window.addEventListener('message', this.onMessage, false);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.onMessage);
        if (this.popup && !this.popup.closed) {
            this.popup.close();
        }
    },
    methods: {
        async login(provider) {
            if (this.pendingProvider) return;

            this.pendingProvider = provider;
            this.popup = this.openWindow('about:blank', 'Acceso seguro | ' + provider);

            try {
                const url = await this.$store.dispatch('fetchOauthUrl', {provider});
                if (this.popup && !this.popup.closed) {
                    this.popup.location.replace(url);
                    this.popup.focus();
                } else {
                    window.location.assign(url);
                }
            } catch (error) {
                if (this.popup && !this.popup.closed) {
                    this.popup.close();
                }
                this.pendingProvider = null;
                this.$toast.error(this.errorMessage(error), {icon: 'mdi-alert-circle'});
            }
        },
        async onMessage(event) {
            if (event.origin !== window.location.origin
                || !event.data
                || event.data.type !== 'valzum:oauth'
                || event.data.provider !== this.pendingProvider) {
                return;
            }

            if (event.data.error || !event.data.token) {
                this.pendingProvider = null;
                this.$toast.error(event.data.error || 'No fue posible completar el acceso.', {icon: 'mdi-alert-circle'});
                return;
            }

            try {
                await this.$store.dispatch('saveToken', {token: event.data.token});
                await this.$store.dispatch('fetchUser');
                this.$toast.success('¡Bienvenido a Valzum!', {icon: 'mdi-check-circle'});
                const destination = this.$route.query.to
                    ? {path: this.$route.query.to}
                    : {name: 'Home'};
                await this.$router.push(destination).catch(() => {});
            } catch (error) {
                this.$store.dispatch('destroy');
                this.$toast.error('El proveedor confirmó el acceso, pero no fue posible cargar tu cuenta.', {icon: 'mdi-alert-circle'});
            } finally {
                this.pendingProvider = null;
            }
        },
        openWindow(url, title) {
            const width = 600;
            const height = 720;
            const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
            const screenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const left = ((viewportWidth - width) / 2) + screenLeft;
            const top = ((viewportHeight - height) / 2) + screenTop;
            const features = `popup=yes,width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;

            return window.open(url, title, features);
        },
        errorMessage(error) {
            const response = error && error.response ? error.response : null;
            if (response && response.status === 503) {
                return 'Este proveedor todavía no está configurado.';
            }

            return response && response.data && response.data.message
                ? response.data.message
                : 'No fue posible iniciar el acceso con este proveedor.';
        }
    }
};
</script>

<style scoped>
.auth-oauth-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
.auth-oauth-button {
    min-width: 132px;
}
</style>
